export const colors = {
  socialIcons: "#69BEBB",
  green: "#19BCCC",
  blue: "#4D63DD",
  primary: "#4D63DD",
  gradient: "linear-gradient(116.34deg, #19BCCC 24.17%, #1FD4A3 123.73%)",
  secondary: "#585757",
  purpleGradient: "linear-gradient(128.8deg, #4D63DD 28.61%, #22A1F5 99.07%)",
}
